import { AliasMacronMapper } from '@at.govt.nz/gtfs-name-mapping-util';
import { featureEnabled } from './FeatureFlagService';
import { AT_API_URL, AT_API_KEY } from '../utils/Config';
import {
  ENABLE_DISPLAY_MACRONS,
  ENABLE_SEARCH_ALIAS,
} from '../constants/featureFlags';

let instance;

export const initAliasMacronService = async () => {
  if (instance) return;

  instance = await AliasMacronMapper.create({
    tablesBaseUrl: `${AT_API_URL}/digital/v2/mappings`,
    requestHeaders: { 'Ocp-Apim-Subscription-Key': AT_API_KEY },
  });
};

export function getMacronisedText(text) {
  const isMacronsEnabled = featureEnabled(ENABLE_DISPLAY_MACRONS, false);

  if (!isMacronsEnabled || !instance) return text;
  return instance.macroniseText(text);
}

export function getAlias(text) {
  const isAliasEnabled = featureEnabled(ENABLE_SEARCH_ALIAS, false);

  if (!isAliasEnabled || !instance) return null;
  return instance.getAlias(text);
}
